export const styles = {
  shell: 'tw-flex tw-flex-row tw-h-full tw-w-full tw-overflow-hidden',
  content: 'tw-flex-1 tw-min-w-0 tw-h-full tw-flex tw-flex-col tw-overflow-hidden tw-bg-neutral-50',
};
